(function() {
  'use strict';

  var currentStep = 1;
  var totalSteps = 5;
  var selectedCategory = '';
  var selectedCondition = '';
  var consentGiven = false;
  var uploadedFiles = [];

  // ---- SYNC HIDDEN FIELDS ----
  function syncHiddenFields() {
    var h = function(id, val) {
      var el = document.getElementById(id);
      if (el) el.value = val;
    };
    h('cpHiddenCategoria', selectedCategory || '');
    h('cpHiddenBrand', document.getElementById('cpBrand').value || '');
    h('cpHiddenModello', document.getElementById('cpModello').value || '');
    h('cpHiddenTaglia', document.getElementById('cpTaglia').value || '');
    h('cpHiddenColore', document.getElementById('cpColore').value || '');
    h('cpHiddenBudget', '\u20AC' + parseInt(document.getElementById('cpBudget').value).toLocaleString('it-IT'));
    h('cpHiddenCondizione', selectedCondition || '');
    h('cpHiddenNote', document.getElementById('cpNote').value || '');
    h('cpHiddenLink', document.getElementById('cpLink').value || '');
    h('cpHiddenInstagram', document.getElementById('cpInstagram').value || '');
    h('cpHiddenTelefono', document.getElementById('cpTelefono').value || '');
  }

  // ---- NAVIGATION ----
  window.cpNextStep = function() {
    if (!validateStep(currentStep)) return;

    if (currentStep < totalSteps) {
      var line = document.getElementById('cpLine' + currentStep);
      if (line) line.classList.add('filled');

      var currentIndicator = document.querySelector('.cp-step-indicator[data-step="' + currentStep + '"]');
      if (currentIndicator) {
        currentIndicator.classList.remove('active');
        currentIndicator.classList.add('completed');
      }

      currentStep++;

      var nextIndicator = document.querySelector('.cp-step-indicator[data-step="' + currentStep + '"]');
      if (nextIndicator) nextIndicator.classList.add('active');

      if (currentStep === 5) buildSummary();

      showPanel(currentStep);
    }
  };

  window.cpPrevStep = function() {
    if (currentStep > 1) {
      var currentIndicator = document.querySelector('.cp-step-indicator[data-step="' + currentStep + '"]');
      if (currentIndicator) currentIndicator.classList.remove('active');

      currentStep--;

      var line = document.getElementById('cpLine' + currentStep);
      if (line) line.classList.remove('filled');

      var prevIndicator = document.querySelector('.cp-step-indicator[data-step="' + currentStep + '"]');
      if (prevIndicator) {
        prevIndicator.classList.remove('completed');
        prevIndicator.classList.add('active');
      }

      showPanel(currentStep);
    }
  };

  function showPanel(step) {
    document.querySelectorAll('.cp-step-panel').forEach(function(p) { p.classList.remove('active'); });
    var panel = document.querySelector('.cp-step-panel[data-panel="' + step + '"]');
    if (panel) {
      panel.classList.add('active');
      panel.style.animation = 'none';
      panel.offsetHeight;
      panel.style.animation = '';
    }
    var wizard = document.getElementById('cpWizard');
    if (wizard) wizard.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ---- VALIDATION ----
  function validateStep(step) {
    clearErrors();
    var valid = true;

    if (step === 1) {
      var taglia = document.getElementById('cpTaglia');
      if (!taglia.value) {
        showError('cpTaglia', 'cpTagliaError');
        valid = false;
      }
    }

    if (step === 2) {
      if (!selectedCondition) {
        document.getElementById('cpConditionError').classList.add('visible');
        valid = false;
      }
    }

    if (step === 4) {
      var nome = document.getElementById('cpNome');
      var cognome = document.getElementById('cpCognome');
      var email = document.getElementById('cpEmail');

      if (!nome.value.trim()) {
        showError('cpNome', 'cpNomeError');
        valid = false;
      }
      if (!cognome.value.trim()) {
        showError('cpCognome', 'cpCognomeError');
        valid = false;
      }
      if (!email.value.trim() || !isValidEmail(email.value)) {
        showError('cpEmail', 'cpEmailError');
        valid = false;
      }
    }

    return valid;
  }

  function showError(inputId, errorId) {
    var input = document.getElementById(inputId);
    var error = document.getElementById(errorId);
    if (input) input.classList.add('error');
    if (error) error.classList.add('visible');
  }

  function clearErrors() {
    document.querySelectorAll('.cp-input.error, .cp-select.error, .cp-textarea.error').forEach(function(el) { el.classList.remove('error'); });
    document.querySelectorAll('.cp-field-error.visible').forEach(function(el) { el.classList.remove('visible'); });
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  // ---- CATEGORY SELECTION ----
  window.cpSelectCategory = function(card) {
    document.querySelectorAll('.cp-category-card').forEach(function(c) { c.classList.remove('selected'); });
    card.classList.add('selected');
    selectedCategory = card.getAttribute('data-value');
    filterSizes(selectedCategory);
  };

  // ---- FILTER SIZES BASED ON CATEGORY ----
  function filterSizes(category) {
    var select = document.getElementById('cpTaglia');
    if (!select) return;
    var options = select.querySelectorAll('option[data-type]');
    select.value = '';
    options.forEach(function(opt) {
      var type = opt.getAttribute('data-type');
      if (category === 'shoes') {
        opt.style.display = (type === 'shoes') ? '' : 'none';
      } else {
        opt.style.display = (type === 'clothing') ? '' : 'none';
      }
    });
  }

  // ---- INIT: hide shoe sizes by default ----
  document.addEventListener('DOMContentLoaded', function() {
    filterSizes('clothing');
  });

  // ---- CONDITION SELECTION ----
  window.cpSelectCondition = function(card) {
    document.querySelectorAll('.cp-condition-card').forEach(function(c) { c.classList.remove('selected'); });
    card.classList.add('selected');
    selectedCondition = card.getAttribute('data-value');
    document.getElementById('cpConditionError').classList.remove('visible');
  };

  // ---- BUDGET SLIDER ----
  window.cpUpdateBudget = function(val) {
    document.getElementById('cpBudgetDisplay').textContent = '\u20AC' + parseInt(val).toLocaleString('it-IT');
    var input = document.getElementById('cpBudget');
    var min = parseInt(input.min);
    var max = parseInt(input.max);
    var pct = ((val - min) / (max - min)) * 100;
    input.style.background = 'linear-gradient(to right, var(--cp-green) 0%, var(--cp-green) ' + pct + '%, var(--cp-dark-gray) ' + pct + '%, var(--cp-dark-gray) 100%)';
  };

  setTimeout(function() { window.cpUpdateBudget(250); }, 100);

  // ---- FILE UPLOAD ----
  window.cpHandleFiles = function(files) {
    for (var i = 0; i < files.length; i++) {
      if (files[i].size > 5 * 1024 * 1024) continue;
      if (uploadedFiles.length >= 5) break;
      uploadedFiles.push(files[i]);
    }
    renderFileList();
  };

  function renderFileList() {
    var list = document.getElementById('cpFileList');
    var zone = document.getElementById('cpUploadZone');
    list.innerHTML = '';
    if (uploadedFiles.length > 0) {
      zone.classList.add('has-files');
    } else {
      zone.classList.remove('has-files');
    }
    uploadedFiles.forEach(function(file, idx) {
      var tag = document.createElement('div');
      tag.className = 'cp-file-tag';
      tag.innerHTML = '\uD83D\uDCC4 ' + file.name + ' <button type="button" class="cp-file-remove" onclick="cpRemoveFile(' + idx + ')">\u2715</button>';
      list.appendChild(tag);
    });
  }

  window.cpRemoveFile = function(idx) {
    uploadedFiles.splice(idx, 1);
    renderFileList();
  };

  var dropZone = document.getElementById('cpUploadZone');
  if (dropZone) {
    dropZone.addEventListener('dragover', function(e) {
      e.preventDefault();
      dropZone.style.borderColor = 'var(--cp-violet)';
      dropZone.style.background = 'rgba(139, 92, 246, 0.06)';
    });
    dropZone.addEventListener('dragleave', function(e) {
      e.preventDefault();
      dropZone.style.borderColor = '';
      dropZone.style.background = '';
    });
    dropZone.addEventListener('drop', function(e) {
      e.preventDefault();
      dropZone.style.borderColor = '';
      dropZone.style.background = '';
      cpHandleFiles(e.dataTransfer.files);
    });
  }

  // ---- CONSENT ----
  window.cpToggleConsent = function() {
    consentGiven = !consentGiven;
    var box = document.getElementById('cpConsentBox');
    var btn = document.getElementById('cpSubmitBtn');
    if (consentGiven) {
      box.classList.add('checked');
      btn.disabled = false;
      document.getElementById('cpConsentError').classList.remove('visible');
    } else {
      box.classList.remove('checked');
      btn.disabled = true;
    }
  };

  // ---- BUILD SUMMARY ----
  function buildSummary() {
    var container = document.getElementById('cpSummary');
    var rows = [
      { key: 'Categoria', value: selectedCategory ? selectedCategory.charAt(0).toUpperCase() + selectedCategory.slice(1) : '\u2014' },
      { key: 'Brand', value: document.getElementById('cpBrand').value || '\u2014' },
      { key: 'Modello', value: document.getElementById('cpModello').value || '\u2014' },
      { key: 'Taglia', value: document.getElementById('cpTaglia').value || '\u2014' },
      { key: 'Colore', value: document.getElementById('cpColore').value || '\u2014' },
      { key: 'Budget max', value: '\u20AC' + parseInt(document.getElementById('cpBudget').value).toLocaleString('it-IT') },
      { key: 'Condizione', value: selectedCondition ? selectedCondition.charAt(0).toUpperCase() + selectedCondition.slice(1) : '\u2014' },
      { key: 'Note', value: document.getElementById('cpNote').value || '\u2014' },
      { key: 'Link', value: document.getElementById('cpLink').value || '\u2014' },
      { key: 'Immagini', value: uploadedFiles.length > 0 ? uploadedFiles.map(function(f) { return f.name; }).join(', ') : '\u2014' },
      { key: 'Nome', value: (document.getElementById('cpNome').value + ' ' + document.getElementById('cpCognome').value).trim() },
      { key: 'Email', value: document.getElementById('cpEmail').value },
      { key: 'Telefono', value: document.getElementById('cpTelefono').value || '\u2014' },
      { key: 'Instagram', value: document.getElementById('cpInstagram').value || '\u2014' }
    ];

    container.innerHTML = '';
    rows.forEach(function(row) {
      var div = document.createElement('div');
      div.className = 'cp-summary-row';
      div.innerHTML = '<div class="cp-summary-key">' + row.key + '</div><div class="cp-summary-value">' + row.value + '</div>';
      container.appendChild(div);
    });
  }

  // ---- FORM SUBMIT ----
  var form = document.getElementById('cpForm');
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      if (!consentGiven) {
        document.getElementById('cpConsentError').classList.add('visible');
        return;
      }

      // Sincronizza i campi hidden prima dell'invio
      syncHiddenFields();

      // Mostra stato di caricamento
      var btn = document.getElementById('cpSubmitBtn');
      var text = document.getElementById('cpSubmitText');
      var arrow = document.getElementById('cpSubmitArrow');
      var spinner = document.getElementById('cpSpinner');

      btn.disabled = true;
      text.textContent = 'Invio in corso...';
      arrow.style.display = 'none';
      spinner.classList.add('active');

      // Invio via AJAX (fetch) al contact form Shopify
      var formData = new FormData(form);

      fetch('/contact', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
      .then(function(response) {
        cpShowSuccess();
      })
      .catch(function() {
        // Fallback: invio tradizionale
        form.submit();
      });
    });
  }

  // ---- SHOW SUCCESS ----
  function cpShowSuccess() {
    document.querySelectorAll('.cp-step-panel').forEach(function(p) { p.classList.remove('active'); });
    var progress = document.getElementById('cpProgress');
    if (progress) progress.style.display = 'none';
    var success = document.getElementById('cpSuccess');
    if (success) success.classList.add('active');
    var ref = 'CP-' + Math.random().toString(36).substr(2, 6).toUpperCase();
    var refEl = document.getElementById('cpRefCode');
    if (refEl) refEl.textContent = 'REF: ' + ref;
    var wizard = document.getElementById('cpWizard');
    if (wizard) wizard.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ---- CHECK SHOPIFY SUCCESS (fallback per invio tradizionale) ----
  if (window.location.hash === '#contact_form' || window.location.search.indexOf('form_type=contact') > -1 || window.location.search.indexOf('customer_posted=true') > -1) {
    document.addEventListener('DOMContentLoaded', function() {
      cpShowSuccess();
    });
  }

  // ---- REAL-TIME VALIDATION ----
  ['cpNome', 'cpCognome', 'cpEmail', 'cpTelefono', 'cpTaglia'].forEach(function(id) {
    var el = document.getElementById(id);
    if (el) {
      el.addEventListener('input', function() {
        this.classList.remove('error');
        var errorEl = document.getElementById(id + 'Error');
        if (errorEl) errorEl.classList.remove('visible');
      });
    }
  });

})();